module.exports = __webpack_public_path__ + "assets/icons/icon_signal3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/icon_signal3.svg
// module id = Iy3b
// module chunks = 1